export function EsignaturesAccountService(
    $filter,
    EsignaturesAccountApi,
    SUBSCRIPTION_PLAN_TYPE,
    BdLocalize,
    Settings
) {
    const service = {};
    
    service.getClientConfiguration = function getClientConfiguration() {
        return EsignaturesAccountApi.getClientConfiguration();
    };

    service.getRentalOwnerClientConfiguration = function getRentalOwnerClientConfiguration() {
        return EsignaturesAccountApi.getRentalOwnerClientConfiguration();
    };
    
    service.enableAccountForEsignature = function enableAccountForEsignature() {
        return EsignaturesAccountApi.enableAccountForEsignature();
    };
    service.accountHasEleaseAgreements = function accountHasEleaseAgreements() {
        return EsignaturesAccountApi.accountHasEleaseAgreements();
    };
    service.accountHasEleaseTemplates = function accountHasEleaseTemplates() {
        return EsignaturesAccountApi.getAccountEleaseTemplatesExistence()
            .then(dto => dto.AccountHasEleaseTemplates);
    };

    service.getEsignatureRequestPriceText = function getEsignatureRequestPriceText(subscriptionPlanType, price) {
        if (subscriptionPlanType && price) {
            const formattedPrice = $filter('currency')(price, '$');
            switch (subscriptionPlanType) {
                case SUBSCRIPTION_PLAN_TYPE.Growth2020:
                case SUBSCRIPTION_PLAN_TYPE.Premium2020:
                    return BdLocalize.getString('Properties.Leasing.Esignatures.Wizard.Pill.FreeUnlimited', 'Free');
                case SUBSCRIPTION_PLAN_TYPE.Pro2016:
                    return BdLocalize.getString('Properties.Leasing.Esignatures.Wizard.Pill.30FreeELeasesUsed', `30 free/mo., then ${formattedPrice}`, [formattedPrice]);
                default:
                    return `${formattedPrice}`;
            }
        }
        return null;
    };

    service.isEsignatureFree = function isEsignatureFree() {
        const freePlans = [SUBSCRIPTION_PLAN_TYPE.Growth2020, SUBSCRIPTION_PLAN_TYPE.Premium2020];
        if (Settings.SubscriberSettingsInfo && freePlans.indexOf(Settings.SubscriberSettingsInfo.CurrentSubscriptionPlanType) > -1) {
            return true;
        }
        return false;
    };

    return service;
}

EsignaturesAccountService.$inject = [
    '$filter',
    'EsignaturesAccountApi',
    'SUBSCRIPTION_PLAN_TYPE',
    'BdLocalize',
    'Settings'
];
